import { render, staticRenderFns } from "./filter_format.vue?vue&type=template&id=3b8fd15f&scoped=true"
import script from "./filter_format.vue?vue&type=script&lang=js"
export * from "./filter_format.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8fd15f",
  null
  
)

export default component.exports